import React from "react";
import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Container } from "./banner.styles";
import { KYCConstants } from "constants/application";
import { AppSpecificMsg } from "constants/headerImage";

function Banner() {
  const { t } = useTranslation();
  const appName:any = localStorage.getItem('appname');
  return (
    <Container>
      
    <Typography variant="h2" color="secondary">
     {AppSpecificMsg[appName]}
    </Typography> 
      
      {/* <Typography sx={{ pt: 1 }} variant="h3" color="secondary">
        {t("proceed", {
          defaultValue:
            "Please proceed with OTP verification to start the KYC process",
        })}
      </Typography> */}
    </Container>
  );
}

export default Banner;
